import { Alias } from './aliases';
import { KeyMapper } from './key-mapper';

export class ObjectKeyMapper {
  readonly #keyMapper!: KeyMapper;

  constructor(keyMapper: KeyMapper) {
    this.#keyMapper = keyMapper;
  }

  toExternal(value: Record<string, unknown>): Record<string, unknown> {
    const entries = Object.entries(value).map(([key, value]) => [
      this.#keyMapper.toExternal(key),
      value,
    ]);
    const rv = Object.fromEntries(entries);
    return rv;
  }

  toInternal(value: Record<string, unknown>): Record<string, unknown> {
    const entries = Object.entries(value).map(([key, value]) => [
      this.#keyMapper.toInternal(key),
      value,
    ]);
    const rv = Object.fromEntries(entries);
    return rv;
  }

  // Agregar nuevas claves delegando a KeyMapper
  add(internal: string, external: string): void;
  add(alias: Alias): void;
  add(internalOrAlias: string | Alias, external?: string): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.#keyMapper.add(internalOrAlias as any, external as any);
  }
}
